import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";

class Notification extends Component {
  state = {
    title: "",
    message: "",
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      title: this.state.title,
      body: this.state.body,
    };

    axios
      .post("/users/create_notification", {
        title: this.state.title,
        message: this.state.message,
      })
      .then((resp) => {
        toast(resp.data.message);
        document.getElementById("notification").reset();
      });
  };

  render() {
    return (
      <div className="row">
        <div className="col-md-6 offset-md-3" style={{ marginTop: 50 + "px" }}>
          <div className="text-center">
            <h4
              className="h4 mb-2 login-welcome-text"
              style={{ marginTop: 20 + "px", fontWeight: "bold" }}
            >
              Create User Notification
            </h4>
            <p style={{ color: "#000524" }}>
              This operation sends notifications to all users in the Jeroid
              application
            </p>
          </div>
          <div
            className="card card-register mx-auto mt-2"
            style={{ border: 0, borderRadius: 0, marginBottom: 10 + "%" }}
          >
            <div
              className="card-header"
              style={{
                backgroundColor: "white",
                borderBottom: 0,
                marginTop: 2 + "%",
                fontWeight: "bold",
              }}
            >
              New notification
            </div>
            <hr
              style={{
                marginRight: 20 + "px",
                marginLeft: 20 + "px",
                marginTop: 0,
                marginBottom: 0,
              }}
            />
            <div className="card-body">
              <form onSubmit={this.handleSubmit} id="notification">
                <input
                  name="title"
                  type="text"
                  className="form-control"
                  placeholder="Title"
                  onChange={this.handleChange}
                  required
                />
                <textarea
                  name="message"
                  type="text"
                  className="mt-3 form-control"
                  placeholder="message"
                  rows="4"
                  onChange={this.handleChange}
                  required
                />
                <button className="btn btn-success mt-3" type="submit">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Notification;
